import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from '../src/app';
import '../src/styles/filepicker.css';
import '../src/styles/input-slider.css';
import '../src/styles/main.css';
import '../src/styles/quill.snow.css';
import '../src/styles/rc-slider.css';
import '../src/styles/react-date-range-styles.css';
// main css file
import '../src/styles/datepicker.css';
import '../src/styles/react-date-range-theme.css';
import '../src/styles/react-toastify.css';
import '../src/styles/react-tooltip.css';
import '../src/styles/tailwind.css';

// theme css file

const element = document.getElementById('__app') as HTMLDivElement;

const root = createRoot(element);

root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);
